module.exports = __webpack_public_path__ + "static/media/test6_name_customcolor_backless_v2_light_dark.3770892f.png";